import { ShieldCheck } from "lucide-react";

export default function TrustScoreRing({ score = 0, size = 64, thin = false, className = "" }) {
  const pct = Math.max(0, Math.min(100, score));
  const label = pct >= 80 ? "Excellent" : pct >= 60 ? "Great" : pct >= 40 ? "Good" : pct >= 20 ? "Building" : "New";
  const color = pct >= 80 ? "#16A34A" : pct >= 60 ? "#84CC16" : pct >= 40 ? "#FBBF24" : "#F97316";
  const r = size / 2 - (thin ? 3 : 5);
  const c = 2 * Math.PI * r;
  const dash = c * (pct / 100);
  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid="trust-score-ring">
      <div className="relative" style={{ width: size, height: size }}>
        <svg width={size} height={size} className="-rotate-90">
          <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={thin ? 4 : 6} stroke="#E5E7EB" fill="none" />
          <circle cx={size / 2} cy={size / 2} r={r} strokeWidth={thin ? 4 : 6} stroke={color} fill="none"
            strokeDasharray={`${dash} ${c}`} strokeLinecap="round" />
        </svg>
        <div className="absolute inset-0 flex items-center justify-center font-bold text-gray-900" style={{ fontSize: size / 3.2 }}>{pct}</div>
      </div>
      <div className="leading-tight">
        <div className="text-xs uppercase tracking-widest text-gray-500 flex items-center gap-1"><ShieldCheck className="h-3 w-3" />Trust</div>
        <div className="font-semibold text-gray-900" style={{ color }}>{label}</div>
      </div>
    </div>
  );
}
